<!--
@component

For text-based user inputs.

```svelte
<TextInput type="email"  on:input={onInput} />
```
-->
<svelte:options immutable />

<script lang="ts">
import type { ClassValue } from 'svelte/elements';

import Input from './input.svelte';
import type { TextInputTypes } from './text-input-types';

/** The input type */
export let type: TextInputTypes | undefined = 'text';

/** The value of the input, if any. */
export let value: string | undefined = undefined;

/** The HTML input element. */
export let input: HTMLInputElement | undefined = undefined;

/** If the input is rendered as readonly or not. */
export let readonly = false;

/** Additional CSS classes to pass to the input. */
let extraClasses: ClassValue = '';
export { extraClasses as cx };
</script>

<Input
  cx={extraClasses}
  {type}
  {readonly}
  {...$$restProps}
  on:input
  on:change
  on:keydown
  on:focus
  on:blur
  bind:value
  bind:input
/>
